import { NgModule } from '@angular/core';

import { RequetsRoutingModule } from './requets-routing.module';
import { TypesComponent } from './types/types.component';
import { CoreModule } from '../../core/core.module';
import { RequestService } from './shared/request.service';
import { RequestComponent } from './request/request.component';
import { StudentsModule } from '../students/students.module';
import { RequestSubjectsComponent } from './request-subjects/request-subjects.component';
import { DocumentTypeComponent } from './document-type/document-type.component';
import { SubjectsComponent } from './subjects/subjects.component';
import { RequestSuccessComponent } from './request-success/request-success.component';
import { SubjectsHistoryComponent } from './subjects-history/subjects-history.component';
import { DocumentsReceptionComponent } from './documents-reception/documents-reception.component';
import { SearchFieldsComponent } from './search-fields/search-fields.component';
import { UserService } from './shared/user.service';
import { RequetsComponent } from './requets.component';
import { CheckDocumentsComponent } from './check-documents/check-documents.component';
import { DocumentDeliveryComponent } from './document-delivery/document-delivery.component';
import { SubjectsProficiencyComponent } from './subjects-proficiency/subjects-proficiency.component';
import { DetailRequestComponent } from './detail-request/detail-request.component';
import { StatusDialogComponent } from './status-dialog/status-dialog.component';
import { DetailRequestPorficienceComponent } from './detail-request-porficience/detail-request-porficience.component';
import { ReportsService } from '../reports/shared/reports.service';
import { ReportsModule } from '../reports/reports.module';


@NgModule({
  imports: [
    CoreModule,
    RequetsRoutingModule,
    StudentsModule
  ],
  declarations: [TypesComponent, RequestComponent,
     RequestSubjectsComponent, DocumentTypeComponent,
     SubjectsComponent, RequestSuccessComponent, SubjectsHistoryComponent,
     DocumentsReceptionComponent, SearchFieldsComponent, RequetsComponent,
     CheckDocumentsComponent, DocumentDeliveryComponent, DetailRequestComponent,
     StatusDialogComponent, SubjectsProficiencyComponent, DetailRequestPorficienceComponent],
  exports: [TypesComponent, RequestComponent,
    RequetsRoutingModule, RequestSubjectsComponent,
    StudentsModule, DocumentTypeComponent, SubjectsComponent,
    RequestSuccessComponent, SubjectsHistoryComponent,
    DocumentsReceptionComponent, SearchFieldsComponent,
    RequetsComponent, CheckDocumentsComponent,
    DocumentDeliveryComponent, DetailRequestComponent, StatusDialogComponent,
    SubjectsProficiencyComponent, DetailRequestPorficienceComponent],
  providers: [ RequestService, UserService, ReportsService ],
  entryComponents : [CheckDocumentsComponent, StatusDialogComponent]
})
export class RequetsModule { }
